import mod from "-!./analyticCode.js?vue&type=script&lang=js&external"; export default mod; export * from "-!./analyticCode.js?vue&type=script&lang=js&external"